import { Box, Flex } from "@mantine/core";

import { CommentResponse } from "types";

import Text from '../../text';
import { TFunction } from "i18next";

interface CommentItemProps {
  border: boolean;
  comment: CommentResponse
  index: number;
  t: TFunction;
}

const CommentItem = ({ border, comment, index, t }: CommentItemProps) => {
  return (
    <Box key={`comment-${comment.id}-${index}`} mb={'md'}>
      <Flex justify={'space-between'} mb={'sm'}>
        <Text size={'xs'} c={'var(--mantine-color-gray-7)'}>{comment.info.createdBy.fullName}</Text>
        <Text size={'xs'} c={'var(--mantine-color-gray-7)'}>{t('format.date_time', { date: new Date(comment.info.createdAt)})}</Text>
      </Flex>
      <Text size={'sm'}>{comment.comment}</Text>
      <Box style={border ? { borderBottom: '1px solid var(--mantine-color-gray-1)' }: {}} my={'sm'}></Box>
    </Box>
  )
}

export default CommentItem;